export class FeatureDisplayItem {
  constructor(
    public featureObject: unknown,
    public getContent: () => null | HTMLElement | string = () => '',
    public click?: (event: MouseEvent) => void,
  ) { }
}
